<template>
	<div class="search-article-results">
		<div class="results container">
			<div v-for="(podcast, index) in currentPage.data" :key="index">
				<podcast-tile :podcast="podcast"></podcast-tile>
			</div>
			
			<ajax-pagination :items-total="currentPage.totalResults" :items-per-page="currentPage.pageSize" 
				:current-page="currentPage.pageNumber" :base-url="currentPage.nakedPageUrl" 
				:query-parameter="currentPage.pageFieldName" @page-changed="changePage"/>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

import AjaxPagination from "../../AjaxPagination.vue";
import PodcastTile from "../PodcastTile.vue";


export default {
  name: "SearchPodcastResults",
  components: { PodcastTile, AjaxPagination },
  
  computed: {
	...mapState("search", ["currentPage"])
  },
  
  methods: {
  	...mapActions("search", ["changePage"])
  }
};
</script>

<style lang="scss" scoped>

</style>